import CrossSellGalleryElement from '../CrossSellGalleryElement/CrossSellGalleryElement';
import MobileCrossSellGalleryElementDefinition from './MobileCrossSellGalleryElementDefinition';
import MobileCrossSellGalleryElementMetaData from './MobileCrossSellGalleryElementMetaData';

export default {
  MobileCrossSellGalleryElement: CrossSellGalleryElement,
  MobileCrossSellGalleryElementDefinition: MobileCrossSellGalleryElementDefinition,
  MobileCrossSellGalleryElementType: MobileCrossSellGalleryElementMetaData.type
};
